export default __webpack_public_path__ + "static/media/microcentrifuge_topview.c9b6e007.svg";